import { Box, Card, Grid, Grid2, styled } from '@mui/material';

export const GridContainer = styled(Grid2)`
    justify-content: space-between;
    margin: 0 0 24px 0;
    padding: 24px 24px 0 24px;
    display: block;
`;

export const GridContainer2 = styled(Grid2)`
    justify-content: space-between;
    margin: 0 24px 24px 24px;
    display: block;
`;

export const ButtonContainer = styled(Box)`
    display: flex;
    justify-content: end;
    border-top: 1px solid #d0d5dd;
    padding: 24px;
`;

export const IntegrationCard = styled(Card)`
    width: 100%;
    min-width: 800px;
    overflow: visible;
`;

export const IntegrationCardPadding = styled(Box)`
    padding: 24px 20px;
    width: 100%;
    overflow: visible;
`;

export const SettingsContainer = styled(Grid2)({
    borderBottom: '1px solid #D0D5DD',
    marginTop: 2,
    justifyContent: 'space-between',
    paddingBottom: '40px'
});

export const ConfirmationBox = styled(Box)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    height: auto;
    background-color: #ffffff;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 5px 20px;
    outline: none;
    display: inline-table;
    justify-content: center;
`;
